// ReportSummary.tsx (refactorizado para usar ReportData)
import React from 'react';
import VulnerabilitiesChart from './Summary/VulnerabilitiesChart';
import CriticalityTable from './Summary/CriticalityTable';
import DigitalRiskChart from './Summary/DigitalRiskChart';
import { ReportData } from '../../types/interfaces';
import { useTranslation } from 'react-i18next';

interface ReportSummaryProps {
  summaryData: ReportData;
}

const ReportSummary: React.FC<ReportSummaryProps> = ({ summaryData }) => {
  const { t } = useTranslation();
  return (
    <div
      className="bg-white p-6 rounded-lg shadow-lg mb-6"
      style={{ boxShadow: '0px 4px 10px rgba(169, 169, 169, 0.6)' }}
    >
      <div className="flex items-center mb-6">
        <div className="w-3 h-10 bg-gray-800 mr-4"></div>
        <h3 className="text-4xl font-bold">{t('reportDetails.summary')}</h3>
      </div>

      <div className="flex flex-col lg:flex-row">
        <div className="lg:w-1/2">
          {/* Paso el summaryData tal cual a la gráfica de vulnerabilidades */}
          <VulnerabilitiesChart summaryData={summaryData} />
        </div>
        <div className="lg:w-1/2">
          {/* Y también a la tabla de criticidad */}
          <CriticalityTable summaryData={summaryData} />
        </div>
      </div>

      {/* Gráfica de riesgo digital */}
      <DigitalRiskChart risk={summaryData.risk} />
    </div>
  );
};

export default ReportSummary;
